import type React from 'react';
import { type Ref } from 'react';

import Slide from '@mui/material/Slide';
import { type TransitionProps } from '@mui/material/transitions';

export const TransitionUp = function Transition({
  ref,
  ...props
}: TransitionProps & { children: React.ReactElement<any, any>; ref?: Ref<unknown> }) {
  return <Slide ref={ref} direction="up" {...props} />;
};
